// removed by extract-text-webpack-plugin
module.exports = {"contact-notes-container":"contact-notes-container"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/ContactInfo/ContactNotes/ContactNotes.scss
// module id = KdoX
// module chunks = 0